import { ApiConfig } from '../../Config.js';
import { DISPUTE_NOTE_MAX_LENGTH } from '../../Constants.js';
import axios from 'axios';

var UploadAllegatoCtrl = function (fn, er, state, token, ids) {
	var caseId = sessionStorage.getItem('caseId')
	var ebox = sessionStorage.getItem('eboxCode')
	var msgEse = state && typeof state.msgEse === 'string' ? state.msgEse : '';

	if (msgEse.length > DISPUTE_NOTE_MAX_LENGTH) {
		er(400);
		return;
	}

	var config = {
		headers: {
			'Authorization': 'Bearer ' + token,
			'Content-Type': 'multipart/form-data',
			"Accept": "application/json",
			"type": "formData",
			'MT_SESSION_ID': ids
		},
	};
	var formData = new FormData();
	for (let i = 0; i < state.valueFile.length; i++) {
		formData.append(`files[${i}]`, state.valueFile[i])
	}	

	formData.append('caseId', caseId);
	formData.append('msgEse', msgEse);
	formData.append('cbEvasione', state.cb_evasione ? "true" : "false");
	formData.append('ebox', ebox);
	// var data = {
	// 	caseId: caseId,
	// 	msgEse: state.msgEse ? state.msgEse : '',
	// 	cb_evasione: state.cb_evasione ? state.cb_evasione : false,
	// 	ebox: ebox,
	// 	files: state.valueFile
	// };
	console.log(formData);

	axios
		.post(ApiConfig.url.EBOX_UPLOAD_ALLEGATO, formData, config)
		.then(function (result) {
			fn(result.data, result.status)
		})
		.catch(function (error) {
			er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
		});
}

export { UploadAllegatoCtrl };
